import {
  Breakpoint,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
// import { ReactComponent as ChannelTalk } from '../../../assets/channelTalk.svg';

interface Props {
  title: string;
  isOpen?: boolean;
  maxWidth?: Breakpoint;
  onClose: () => void;
}

function Confirm(props: Props) {
  const { title, isOpen = false, maxWidth = 'xs', onClose } = props;
  const navigate = useNavigate();

  return (
    <Dialog maxWidth={maxWidth} open={isOpen} onClose={onClose}>
      <DialogTitle>
        <DialogActions>
          <Button
            variant="text"
            onClick={onClose}
            sx={{ marginRight: '-20px', color: 'black' }}
          >
            <CloseIcon />
          </Button>
        </DialogActions>
        <Typography sx={{ fontSize: '24px', fontWeight: 700 }}>
          Та и-мэйлийг мартсан уу?
        </Typography>
      </DialogTitle>
      <DialogContent
        sx={{
          whiteSpace: 'pre-line',
          wordBreak: 'keep-all',
          lineHeight: '24px',
        }}
      >
        <Typography sx={{ fontSize: '16px', fontWeight: '700' }}>
          1. Хэрэв та зөвхөн вэбсайтад бүртгүүлсэн бол:
        </Typography>
        ENR-д гишүүнчлэл бүртгүүлэх нь вэбсайтын гишүүнчлэлээс тусад нь
        шаардлагатай!
        <div style={{ marginTop: '15px', marginBottom: '20px' }}>
          <Button
            fullWidth
            size="large"
            variant="outlined"
            style={{ cursor: 'pointer' }}
            onClick={() => navigate('/signup')}
          >
            SMART ENR БҮРТГҮҮЛЭХ
          </Button>
        </div>
        <Typography sx={{ fontSize: '16px', fontWeight: '700' }}>
          2. Хэрэв та ENR-ийн гишүүнээр бүртгүүлсэн боловч ID-гаа мартсан бол:
        </Typography>
        Доорх “Холбоо барих” товчийг дарж, сургууль, оюутны дугаар болон нэрээ
        бөглөнө үү.
        <div style={{ marginTop: '1rem', marginBottom: '30px' }}>
          <Button
            fullWidth
            size="large"
            variant="outlined"
            style={{ cursor: 'pointer' }}
            onClick={() => window.open('https://vd48q.channel.io/')}
          >
            Холбоо барих
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default Confirm;
